import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import "dayjs/locale/es";
import "dayjs/locale/hu";
import "dayjs/locale/pl";
import "dayjs/locale/pt";
import "dayjs/locale/ro";

export default dayjs.extend(customParseFormat);
